export const AI_CLERK_HOME_HERO_COPY_VARIANT = {
  TEAM_PHOTO: 'team_photo',
  FILE_RESULT: 'file_result'
} as const

export type AiClerkHomeHeroCopyVariant =
  (typeof AI_CLERK_HOME_HERO_COPY_VARIANT)[keyof typeof AI_CLERK_HOME_HERO_COPY_VARIANT]

/**
 * 将神策实验值收敛到前端支持的枚举。
 *
 * 对照组文案已下线（实验 12356 数据对照组转化 0.134% 显著落后，
 * 2026-09-17 决策删除，流量改为 B/C 五五分）；异常值、拉取超时兜底、
 * 以及神策侧可能残留的 control 值一律回退到 B 组 team_photo。
 */
export function normalizeAiClerkHomeHeroCopyVariant(
  value: unknown
): AiClerkHomeHeroCopyVariant {
  return value === AI_CLERK_HOME_HERO_COPY_VARIANT.FILE_RESULT
    ? value
    : AI_CLERK_HOME_HERO_COPY_VARIANT.TEAM_PHOTO
}
